import { createSlice } from "@reduxjs/toolkit";
import { BuscaComparativoResultadoModel } from "../../../models/comparativoResultado/buscaComparativoResultadoModel";
import { ComparativoResultadoModel } from "../../../models/comparativoResultado/comparativoResultadoModel";
import { buscarComparativoResultado, buscarComparativoResultadoEmpresa } from "../../../services/comparativoResultadoService";
import { resetAll } from "../../actions/actions";
import { ComparativoResultadoEmpresaModel } from "../../../models/comparativoResultado/comparativoResultadoEmpresaModel";

export interface ComparativoResultadoState {
  //buscar comparativo resultado
  loading: boolean;
  busca: BuscaComparativoResultadoModel;
  list: ComparativoResultadoEmpresaModel[];
  entity: ComparativoResultadoEmpresaModel;
  //buscar comparativo resultado empresa
  loadingEmpresa: boolean;
  listEmpresa: ComparativoResultadoModel[];
}

const initialState: ComparativoResultadoState = {
  //buscar comparativo resultado
  loading: false,
  busca: {
    idEmpresa: null,
    dataSorteio: null,
    tipoResultado: null,
  },
  list: [],
  entity: {} as ComparativoResultadoEmpresaModel,
  //buscar comparativo resultado
  loadingEmpresa: false,
  listEmpresa: [],
};

export const comparativoResultadoSlice = createSlice({
  name: "comparativoResultado",
  initialState,
  reducers: {
    //buscar comparativo resultado
    setBuscaComparativoResultado: (state, action) => {
      state.busca = action.payload;
    },
    setEntityComparativoResultado: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    resetListComparativoResultado: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar comparativo resultado
    builder.addCase(buscarComparativoResultado.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarComparativoResultado.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarComparativoResultado.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar comparativo resultado empresa
    builder.addCase(buscarComparativoResultadoEmpresa.pending, (state) => {
      state.loadingEmpresa = true;
    });
    builder.addCase(buscarComparativoResultadoEmpresa.fulfilled, (state, action) => {
      state.listEmpresa = action.payload;
      state.loadingEmpresa = false;
    });
    builder.addCase(buscarComparativoResultadoEmpresa.rejected, (state, action) => {
      state.loadingEmpresa = false;
    });
  },
});

export const {
  //buscar comparativo resultado
  setBuscaComparativoResultado,
  setEntityComparativoResultado,
  //internal
  resetListComparativoResultado,
} = comparativoResultadoSlice.actions;

export default comparativoResultadoSlice.reducer;
